@if (initialized && kpiHeaderDto) {
    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/wf/config"
    ></kpi-header>

}